import React from "react";
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { change } from 'redux-form';
import { Button } from "react-bootstrap";
import cx from 'classnames';

import Loader from '../../Common/Loader'
import Dropzone from '../../Common/Dropzone/Dropzone'
import ToolTipContent from "../ToolTipContent/ToolTipContent";


import { updateFavIcon } from "../../../actions/siteadmin/updateFavIcon";

import TrashIcon from '../../../../public/Icons/delete.svg';
import defaultIcon from '../../../../public/Icons/defaultImage.svg';

import s from './ImageUploadComponent.css';

class ImageUploadComponent extends React.Component {

	handleDropzone = (fileName, fieldName, formName) => {
		const { change, updateFavIcon } = this.props;
		change(formName, fieldName, fileName)
		if (fieldName === 'favicon') updateFavIcon(fileName);
	};

	render() {

		const { imageSrc, label, className, defaultMessage, loader, inputContainer, inputContainerClass, loaderName, isLoaderExist } = this.props;
		const { postUrl, handleDropzone, fieldName, formName, isDelete, handleDelete, subTextClass, subText, labelClass, toolTip, isBottom } = this.props;

		return (
			<div>
				{label && <label className={cx(labelClass, 'tooltipLabelContainer', 'svgImg')}>{label} {toolTip && <ToolTipContent label={toolTip} isBottom={isBottom} />}</label>}

				{imageSrc &&
					<Loader show={loader} type={"page"} dropzoneLoaderClass={"dropzoneLoaderContainer"}>
						<div className={s.backgroundImg} style={{ backgroundImage: `url(${imageSrc})` }} />
						{isDelete && <Button onClick={handleDelete} className={cx(s.btnTrash, 'btnTrashRtl')}><img src={TrashIcon} alt='Delete' /> </Button>}
					</Loader>
				}
				{!imageSrc && !isLoaderExist && (
					<Loader show={loader} type="page" dropzoneLoaderClass={"dropzoneLoaderContainer"}>
						<div
							className={cx(s.backgroundImg, 'defaultProfileIcon')}
							style={{ backgroundImage: `url(${defaultIcon})` }}
						/>
					</Loader>
				)}
				<div>
					<Dropzone
						className={className}
						subTextClass={subTextClass}
						subText={subText}
						defaultMessage={defaultMessage}
						componentConfig={{
							iconFiletypes: ['.jpg', '.png', '.svg'],
							multiple: false,
							showFiletypeIcon: false,
							postUrl
						}}
						loaderName={loaderName}
						fieldName={fieldName}
						formName={formName}
						handleDropzone={handleDropzone ? handleDropzone : this.handleDropzone}
						inputContainer={inputContainer}
						inputContainerClass={inputContainerClass}
						isLoader
					/>
				</div>
			</div >
		)
	}
}


const mapState = state => ({});

const mapDispatch = {
	updateFavIcon,
	change
};

export default withStyles(s)(connect(mapState, mapDispatch)(ImageUploadComponent));  